<fieldset>
  <label class="form-check mb-0">
    <input [(ngModel)]="ClaimDto.isClaimTestData" [disabled]="ClaimDto.isLocked && !ClaimDto.isClaimTestData" (change)="setIsClaimTestData()" class="form-check-input" type="checkbox">
    <span class="form-check-label">Test data</span>
  </label>
</fieldset>
